import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsContactAdministratorRoute: InvariantJiraRoute = {
	name: 'global-settings-contact-administrator',
	path: '/jira/contact-administrator',
};
